"use strict";

define('RunnerSaddleModel',[], function () {

    function RunnerSaddle(backColor, numColor, horseId, horseName, bettingInterestNumber) {
        this.backgroundColor = backColor;
        this.numberColor = numColor;
        this.horseId = horseId;
        this.horseName = horseName;
        this.bettingInterestNumber = bettingInterestNumber;
    }

    return RunnerSaddle;

});


